import { AnimatedImages, FunnelImage, ReviewCard, ScreenBackground } from '../Content';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

export enum SectionInformationalDynamicType {
  TITLE = 'TITLE',
  TEXT = 'TEXT',
  DISCLAIMER = 'DISCLAIMER',
  IMAGE = 'IMAGE',
  SPACE = 'SPACE',
  ANIMATED_IMAGE = 'ANIMATED_IMAGE',
  REVIEW_CARD = 'REVIEW_CARD',
  SOCIAL_PROOF = 'SOCIAL_PROOF',
  BANNER = 'BANNER',
  PROGRESS_BAR = 'PROGRESS_BAR',
  PROMO_CODE = 'PROMO_CODE',
}

export type SocialProof = {
  image: FunnelImage;
  topText: string;
  rating: number;
  bottomText: string;
};

export type Banner = {
  image: FunnelImage;
  title: string;
  subtitle: string;
};

export type PromoCode = {
  code: string;
  icon?: FunnelImage;
};

export type ProgressBarValue = {
  start: number;
  finish: number;
  duration?: number;
  color?: string;
};

type SectionText = {
  type:
    | SectionInformationalDynamicType.TITLE
    | SectionInformationalDynamicType.TEXT
    | SectionInformationalDynamicType.DISCLAIMER;
  value: string;
};

type SectionImage = {
  type: SectionInformationalDynamicType.IMAGE;
  value: FunnelImage & { limit?: number };
};

type SectionSpace = {
  type: SectionInformationalDynamicType.SPACE;
  value: VariantSpaceInformationalDynamic;
};

type SectionAnimatedImage = {
  type: SectionInformationalDynamicType.ANIMATED_IMAGE;
  value: AnimatedImages;
  limit?: number;
};

type SectionReviewCard = {
  type: SectionInformationalDynamicType.REVIEW_CARD;
  value: ReviewCard;
};

type SectionSocialProof = {
  type: SectionInformationalDynamicType.SOCIAL_PROOF;
  value: SocialProof;
};

type SectionBanner = {
  type: SectionInformationalDynamicType.BANNER;
  value: Banner;
};

type SectionProgressBar = {
  type: SectionInformationalDynamicType.PROGRESS_BAR;
  value: ProgressBarValue;
};

type SectionPromoCode = {
  type: SectionInformationalDynamicType.PROMO_CODE;
  value: PromoCode;
};

export type SectionInformationalDynamic =
  | SectionText
  | SectionImage
  | SectionSpace
  | SectionAnimatedImage
  | SectionReviewCard
  | SectionSocialProof
  | SectionBanner
  | SectionProgressBar
  | SectionPromoCode;

export type VariantInformationalDynamic = 'primary' | 'secondary';
export type VariantSpaceInformationalDynamic =
  'extra-small' | 'small' | 'medium' | 'large' | 'full';

export interface InformationalDynamicScreenAttributes extends BaseScreenAttributes {
  dataKey: string;
  variant?: VariantInformationalDynamic;
  hasGradient?: boolean;
  content: {
    sections: Array<SectionInformationalDynamic>;
    backgroundImage?: ScreenBackground;
    button: string;
    disclaimer?: string;
  };
  screenType: ScreenType.INFORMATIONAL_DYNAMIC;
}
